import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { DayforceJobsIssuesMain } from './components/DayforceJobsIssuesMain'
import { DayforceJobsIssuesProvider } from './context/DayforceJobsIssuesProvider'
import { DayforceAgenciesProvider } from '../shared/context/DayforceAgenciesProvider'

export const DayforceJobsIssues = () => {
  return (
    <NuqsAdapter>
      <DayforceAgenciesProvider>
        <DayforceJobsIssuesProvider>
          <DayforceJobsIssuesMain />
        </DayforceJobsIssuesProvider>
      </DayforceAgenciesProvider>
    </NuqsAdapter>
  )
}
